export default "__VITE_ASSET__DgIZTHkX__"